const ENS = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="url(#paint0_linear_2140_2572)" />
    <path
      d="M5.66745 8.75942C5.79593 9.03403 6.1139 9.57684 6.1139 9.57684L9.78987 3.5L6.20223 6.00525C5.98846 6.14786 5.81307 6.3409 5.69154 6.56732C5.52814 6.90891 5.44133 7.28207 5.43717 7.66071C5.43301 8.03935 5.5116 8.41432 5.66745 8.75942V8.75942Z"
      fill="white"
    />
    <path
      d="M4.21086 10.7604C4.25137 11.3417 4.4156 11.9076 4.69257 12.4203C4.96953 12.9329 5.35283 13.3805 5.81679 13.733L9.78504 16.5C9.78504 16.5 7.30228 12.922 5.20815 9.36167C4.99614 8.98552 4.85361 8.57426 4.78739 8.14759C4.75808 7.95438 4.75808 7.75785 4.78739 7.56464C4.73279 7.66581 4.6268 7.87297 4.6268 7.87297C4.41446 8.30603 4.26985 8.76911 4.19802 9.24604C4.15667 9.7502 4.16097 10.2571 4.21086 10.7604V10.7604Z"
      fill="white"
    />
    <path
      d="M14.3343 11.2406C14.2059 10.966 13.8879 10.4232 13.8879 10.4232L10.2119 16.5L13.7996 13.9963C14.0133 13.8537 14.1887 13.6607 14.3102 13.4343C14.4739 13.0925 14.5608 12.719 14.565 12.3401C14.5692 11.9612 14.4904 11.5859 14.3343 11.2406V11.2406Z"
      fill="white"
    />
    <path
      d="M15.791 9.23959C15.7505 8.65831 15.5862 8.0924 15.3093 7.57974C15.0323 7.06709 14.649 6.61952 14.185 6.26702L10.2168 3.5C10.2168 3.5 12.698 7.07801 14.7937 10.6384C15.0051 11.0146 15.1471 11.4259 15.2128 11.8524C15.2422 12.0456 15.2422 12.2422 15.2128 12.4354C15.2674 12.3342 15.3734 12.1271 15.3734 12.1271C15.5858 11.694 15.7304 11.2309 15.8022 10.754C15.8441 10.2499 15.8403 9.74302 15.791 9.23959Z"
      fill="white"
    />
    <path
      d="M5.69153 6.56732C5.81306 6.3409 5.98844 6.14786 6.20222 6.00525L9.78986 3.5L6.11389 9.57844C6.11389 9.57844 5.7927 9.03564 5.66744 8.76102C5.51134 8.41571 5.43262 8.04044 5.43678 7.66151C5.44094 7.28257 5.52789 6.90913 5.69153 6.56732V6.56732ZM4.21086 10.7604C4.25137 11.3417 4.4156 11.9076 4.69257 12.4203C4.96953 12.9329 5.35282 13.3805 5.81679 13.733L9.78504 16.5C9.78504 16.5 7.30228 12.922 5.20815 9.36164C4.99614 8.98549 4.85361 8.57423 4.78739 8.14756C4.75808 7.95435 4.75808 7.75782 4.78739 7.56461C4.73279 7.66578 4.6268 7.87295 4.6268 7.87295C4.41446 8.306 4.26985 8.76908 4.19802 9.24601C4.15667 9.75017 4.16097 10.257 4.21086 10.7604V10.7604ZM14.3282 11.2422C14.1997 10.9676 13.8818 10.4248 13.8818 10.4248L10.2122 16.5L13.7999 13.9964C14.0136 13.8537 14.189 13.6607 14.3106 13.4343C14.4742 13.0925 14.5611 12.719 14.5653 12.3401C14.5695 11.9612 14.4907 11.5859 14.3346 11.2406L14.3282 11.2422ZM15.7848 9.2412C15.7443 8.65992 15.5801 8.094 15.3031 7.58135C15.0261 7.06869 14.6428 6.62113 14.1789 6.26862L10.217 3.5C10.217 3.5 12.6982 7.07801 14.7939 10.6384C15.0054 11.0146 15.1474 11.4259 15.2131 11.8524C15.2424 12.0456 15.2424 12.2422 15.2131 12.4354C15.2677 12.3342 15.3737 12.1271 15.3737 12.1271C15.586 11.694 15.7306 11.2309 15.8025 10.754C15.8443 10.2499 15.8406 9.74302 15.7912 9.23959L15.7848 9.2412Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2140_2572"
        x1="4"
        y1="2"
        x2="15.5"
        y2="18.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8098FA" />
        <stop offset="1" stop-color="#4DB5F2" />
      </linearGradient>
    </defs>
  </svg>
);
export default ENS;
